export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all": [
  ],
  "actions": [
    {
      title: "Edit",
      cls: "edit-team",
      icon: "pencil",
      disabled:false
    }
  ]
};


// WEBPACK FOOTER //
// ./src/pages/teamMembers/filter/actionOptions.js